import { DefaultLogscordPublicDefaultImagePath } from "./manifest.js";
export const DefaultLogscordPublicExternalUrls = {
    linkedin: "https://www.linkedin.com/company/logscord/",
    npm: "https://www.npmjs.com/org/logscord",
    github: "https://github.com/LogsCord",
    discord: "https://discord.gg/hpqqU9NUyh",
    topgg: "https://top.gg/bot/1224342989414076507",
};
export function createLogscordPublicSocialLinks(overrides = {}) {
    const urls = {
        ...DefaultLogscordPublicExternalUrls,
        ...Object.fromEntries(Object.entries(overrides).filter(([, value]) => Boolean(value))),
    };
    return [
        { label: "LinkedIn", href: urls.linkedin, icon: "linkedin" },
        { label: "npm", href: urls.npm, icon: "npm" },
        { label: "GitHub", href: urls.github, icon: "github" },
        { label: "Discord", href: urls.discord, icon: "discord" },
        { label: "Top.gg", href: urls.topgg, icon: "topgg" },
    ];
}
export function createLogscordSiteIdentity(siteUrl, defaultImage = DefaultLogscordPublicDefaultImagePath) {
    return {
        url: siteUrl.replace(/\/$/, ""),
        name: "LogsCord",
        defaultImage,
        themeColor: "#6f5cff",
        author: "LogsCord",
        applicationName: "LogsCord",
        twitterCard: "summary_large_image",
    };
}
//# sourceMappingURL=siteIdentity.js.map